import Grid from '@blocks/Grid'
import Sidepanel from '@blocks/Sidepanel'
import React from 'react'
import useSalonGalleryArchive from './hooks/useSalonGalleryArchive'
import useSalonGalleryComponent from './hooks/useSalonGalleryComponent'

export default function SalonGallerySidepanel({ photos, onChoose }: Props) {
    const archive = useSalonGalleryArchive(photos)
    const SalonGalleryComponent = useSalonGalleryComponent({ onChoose })
    archive.useComponent(SalonGalleryComponent)
    
    return (
        <Sidepanel heading="Gallery">
            <Grid gap="20px">
                <Grid gap="10px">
                    <h3 className="h4">Choose the photo from the gallery</h3>
                    <p>The photos you submit to salons are stored in your gallery. You can submit them to other salons or sections without reuploading.</p>
                </Grid>
                {archive.element}
            </Grid>
        </Sidepanel>
    )
}

// TYPES
interface Props  {
    onChoose(photo: Interfaces.Photo): Promise<void>
    photos: Interfaces.Photo[] | undefined
}